// axios
import axios from 'axios'
import Vue from 'vue'
import baseConfig from '@/../baseConfig'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
   headers: {"Access-Control-Allow-Origin": "*"}
})

axiosIns.interceptors.request.use(
  config => {
    // Do something before request is sent

    const accessToken = localStorage.getItem('accessToken')
    const currentOrganizationId = localStorage.getItem('currentOrganizationId')

    // eslint-disable-next-line no-param-reassign
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`
    if (currentOrganizationId) config.headers.currentOrganizationId = currentOrganizationId
    else config.headers.currentOrganizationId = 0
    config.headers.appId = baseConfig.appId
    return config
  },
  error => Promise.reject(error),
)

Vue.prototype.$http = axiosIns

export default axiosIns
